import { render } from "./contactForm.vue?vue&type=template&id=f6ca8e98&scoped=true"
import script from "./contactForm.vue?vue&type=script&lang=js"
export * from "./contactForm.vue?vue&type=script&lang=js"

import "./contactForm.vue?vue&type=style&index=0&id=f6ca8e98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ca8e98"]])

export default __exports__